// Detail content voor /aanbod-detailpagina's. Teksten zijn concept, geen em-dashes.

export const AANBOD_DETAILS = {
    "hd-sessie-basis": {
        key: "basis",
        slug: "hd-sessie-basis",
        naam: "HD sessie basis",
        duur: "1 uur",
        prijs: "95 euro",
        intro:
            "Je eerste kennismaking met je eigen bodygraph. In een uur kijken we samen naar je persoonlijke blauwdruk en zet je een eerste concrete stap.",
        voorWie:
            "Voor iedereen die nieuwsgierig is naar Human Design en wil weten wat het voor jou betekent. Je hoeft er vooraf niets van te weten.",
        watDoen:
            "Ik leg uit wat je type is en hoe jij van nature het beste beslissingen neemt, je autoriteit. We staan stil bij je sterke punten en je uitdagingen. Human Design is de kaart, en waar het helpt pak ik er NLP of lichaamswerk bij, zodat je het niet alleen begrijpt maar ook voelt.",
        meeneemt: [
            "Inzicht in je type en je manier van beslissen.",
            "Zicht op je talenten en je uitdagingen.",
            "Praktische handvatten om verder te gaan.",
            "Ruimte voor jouw vragen. Het is jouw sessie.",
        ],
        praktisch:
            "1 uur, online via Google Meet. Vooraf gebruik ik je geboortedatum, geboortetijd en geboorteplaats om je bodygraph te maken. Prijs: 95 euro.",
        cta: { type: "book" },
    },
    "hd-sessie-uitgebreid": {
        key: "uitgebreid",
        slug: "hd-sessie-uitgebreid",
        naam: "HD sessie uitgebreid",
        duur: "2 uur aaneengesloten",
        prijs: "195 euro",
        intro:
            "Twee uur aaneengesloten, zodat we dieper kunnen gaan dan in een basissessie.",
        voorWie:
            "Voor wie meer tijd en diepgang wil, of al wat met Human Design bezig is.",
        watDoen:
            "Alles uit de basissessie, maar met meer ruimte. We gaan verder in op je kanalen en poorten, je profiel, en op de thema's die voor jou spelen. Omdat we twee uur hebben, is er plek om een patroon bij de kop te pakken met NLP, lichaamswerk of een korte opstelling.",
        meeneemt: [
            "Een vollediger beeld van je bodygraph.",
            "Ruimte om op jouw thema's in te gaan.",
            "Een concrete stap die je meteen kunt zetten.",
        ],
        praktisch:
            "2 uur aaneengesloten in één afspraak, online via Google Meet. Je geboortegegevens heb ik vooraf nodig. Prijs: 195 euro.",
        cta: { type: "book" },
    },
    "verdiepingssessie": {
        key: "verdieping",
        slug: "verdiepingssessie",
        naam: "Verdiepingssessie",
        duur: "1 uur",
        prijs: "95 euro",
        intro:
            "Een losse sessie voor één specifieke vraag. Jij kiest het onderwerp.",
        voorWie:
            "Voor wie al een sessie heeft gehad en gericht aan de slag wil met een onderwerp: een keuze, een patroon, een relatie of je werk.",
        watDoen:
            "We nemen jouw vraag als startpunt en kijken wat je bodygraph erover laat zien. Daarna gaan we voelen en toepassen, zodat je met een concrete volgende stap weggaat.",
        meeneemt: [
            "Helderheid op jouw vraag.",
            "Een volgende stap die bij je past.",
        ],
        praktisch: "1 uur, online via Google Meet. Prijs: 95 euro.",
        cta: { type: "book" },
    },
    "hd-traject": {
        key: "traject",
        slug: "hd-traject",
        naam: "HD traject",
        duur: "10 sessies van 1 uur",
        prijs: "995 euro",
        intro:
            "Tien sessies over een langere periode, zodat je je Human Design echt gaat leven in plaats van alleen begrijpen.",
        voorWie: "Voor wie stappen wil zetten en daar langer begeleiding bij wil.",
        watDoen:
            "We beginnen bij je blauwdruk en bouwen van daaruit op. Sessie voor sessie werken we aan de thema's die voor jou belangrijk zijn, met Human Design als rode draad en NLP, lichaamswerk en familieopstellingen waar ze helpen.",
        meeneemt: [
            "Begeleiding over een langere periode.",
            "Tijd om je blauwdruk eigen te maken.",
            "Een rode draad door jouw thema's.",
        ],
        praktisch:
            "10 sessies van 1 uur over een langere periode, online via Google Meet. Prijs: 995 euro. Je plant nu de eerste sessie in, de overige negen stemmen we samen af.",
        cta: { type: "book" },
    },
    "avond-workshop": {
        key: null,
        slug: "avond-workshop",
        naam: "Avond workshop",
        duur: "1 avond, max 6 personen",
        prijs: "295 euro per persoon",
        intro:
            "Een avond over Human Design in een kleine groep van maximaal zes mensen.",
        voorWie:
            "Voor wie Human Design liever samen met anderen ontdekt, in een ontspannen sfeer.",
        watDoen:
            "Ik leg uit hoe Human Design werkt. Daarna komt ieders eigen blauwdruk aan bod. Vragen stellen mag de hele avond, daar is volop tijd voor. Zo ervaar je zonder drempel wat Human Design voor jou kan betekenen.",
        meeneemt: [
            "Een helder beeld van Human Design.",
            "Je eigen blauwdruk in grote lijnen.",
        ],
        praktisch:
            "Een avond, maximaal 6 personen, 295 euro per persoon. Er zijn nog geen vaste data.",
        cta: { type: "waitlist" },
    },
};

export const AANBOD_SLUGS = Object.keys(AANBOD_DETAILS);
